import moment from 'moment';
import React, { Component } from 'react'
import { Datos_Empresa, development } from "../../../libs/utils/Const";

const formatNumber = (num = "") => {
    const separador = ','; // separador para los miles
    const sepDecimal = '.'; // separador para los decimales

    let splitStr = num.split('.');
    let splitLeft = splitStr[0];
    let splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : '';
    let regex = /(\d+)(\d{3})/;

    while (regex.test(splitLeft)) { splitLeft = splitLeft.replace(regex, "$1" + separador + "$2"); }
    return splitLeft + splitRight;
};

const finalDocStyles = {
    fontSize: { fontSize: 12 },
    colNormal: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
    colNumber: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "right" },
}

const previewStyles = {
    colNormal: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
    colNumber: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "right" },
}

class CreditWallet extends Component {
    render() {
        const { DocsToPrint, ReportsModel, finalDoc } = this.props;
        const styles = finalDoc ? finalDocStyles : previewStyles;

        let branchTotalUnexpired = 0.0;
        let branchTotalExpired1_30 = 0.0;
        let branchTotalExpired31_60 = 0.0;
        let branchTotalExpired61_90 = 0.0;
        let branchTotalExpired90_M = 0.0;
        let branchTotals = 0.0;

        return (
            <div className="p-4">
                <div style={styles.fontSize}>
                    <img style={{height:'5vh'}} src={development ? require('../../../images/logo_draft.svg') : require('../../../images/logo_EMPRESA.svg')} alt="Logo" />
                    {Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}
                </div>
                <div>
                    <p className="font-weight-bold h5">ANTIGÜEDAD DE SALDOS DE CLIENTES</p>
                </div>
                <div style={styles.fontSize}>
                    {moment().format("DD/MM/YYYY")} - {moment().format("HH:mm:ss")} <br /> SUC: {ReportsModel.SucursalName && ReportsModel.SucursalName !== "---" ? ReportsModel.SucursalName : "SIN SUCURSAL"}
                </div>

                {Object.entries(DocsToPrint[0]).map(([key, value]) => {
                    let businessTotalUnexpired = 0.0;
                    let businessTotalExpired1_30 = 0.0;
                    let businessTotalExpired31_60 = 0.0;
                    let businessTotalExpired61_90 = 0.0;
                    let businessTotalExpired90_M = 0.0;
                    let businessTotals = 0.0;

                    let documents = (
                        <div className='mt-3'>
                            <p className="h6">{key}</p>

                            <div style={styles.fontSize}>
                                <table className="border border-dark" style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th style={styles.colNormal}>Serie</th>
                                            <th style={styles.colNormal}>Factura</th>
                                            <th style={styles.colNormal}>Folio SAP</th>
                                            <th style={styles.colNormal}>Tipo</th>
                                            <th style={styles.colNormal}>Fecha</th>
                                            <th style={styles.colNormal}>Vence</th>
                                            <th style={styles.colNumber}>Dias V.</th>
                                            <th style={styles.colNormal}>Condiciones</th>
                                            <th style={styles.colNumber}>No Vencido</th>
                                            <th style={styles.colNumber}>1-30 Días</th>
                                            <th style={styles.colNumber}>31-61 Días</th>
                                            <th style={styles.colNumber}>61-91 Días</th>
                                            <th style={styles.colNumber}>Más de 90 D</th>
                                            <th style={styles.colNumber}>Importe</th>
                                            <th style={styles.colNormal}>Vendedor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {value.map((doc) => {
                                            if (Number(doc.DiasVencidos) < 1) businessTotalUnexpired += Number(doc.Saldo);
                                            else if (Number(doc.DiasVencidos) > 0 && Number(doc.DiasVencidos) < 31) businessTotalExpired1_30 += Number(doc.Saldo);
                                            else if (Number(doc.DiasVencidos) > 30 && Number(doc.DiasVencidos) < 61) businessTotalExpired31_60 += Number(doc.Saldo);
                                            else if (Number(doc.DiasVencidos) > 60 && Number(doc.DiasVencidos) < 91) businessTotalExpired61_90 += Number(doc.Saldo);
                                            else if (Number(doc.DiasVencidos) > 90) businessTotalExpired90_M += Number(doc.Saldo);

                                            businessTotals += Number(doc.Saldo);
                                            return (
                                                <tr key={doc.DocNum}>
                                                    <td style={styles.colNormal}>{doc.Serie || "-"}</td>
                                                    <td style={styles.colNormal}>{doc.DocNum}</td>
                                                    <td style={styles.colNormal}>{doc.DocNum}</td>
                                                    <td style={styles.colNormal}>{doc.isIns === 'Y' ? 'RESERVA' : 'DIRECTA'}</td>
                                                    <td style={styles.colNormal}>{moment(new Date(doc.Fecha)).format("DD/MM/YYYY")}</td>
                                                    <td style={styles.colNormal}>{moment(new Date(doc.DocDueDate)).format("DD/MM/YYYY")}</td>
                                                    <td style={styles.colNumber}>{doc.DiasVencidos}</td>
                                                    <td style={styles.colNormal}>{doc.Condiciones}</td>
                                                    <td style={styles.colNumber}>{Number(doc.DiasVencidos) < 1 ? formatNumber(Number(doc.Saldo).toFixed(2)) : "0.00"}</td>
                                                    <td style={styles.colNumber}>{Number(doc.DiasVencidos) > 0 && Number(doc.DiasVencidos) < 31 ? formatNumber(Number(doc.Saldo).toFixed(2)) : "0.00"}</td>
                                                    <td style={styles.colNumber}>{Number(doc.DiasVencidos) > 30 && Number(doc.DiasVencidos) < 61 ? formatNumber(Number(doc.Saldo).toFixed(2)) : "0.00"}</td>
                                                    <td style={styles.colNumber}>{Number(doc.DiasVencidos) > 60 && Number(doc.DiasVencidos) < 91 ? formatNumber(Number(doc.Saldo).toFixed(2)) : "0.00"}</td>
                                                    <td style={styles.colNumber}>{Number(doc.DiasVencidos) > 90 ? formatNumber(Number(doc.Saldo).toFixed(2)) : "0.00"}</td>
                                                    <td style={styles.colNumber}>{formatNumber(Number(doc.Saldo).toFixed(2))}</td>
                                                    <td style={styles.colNormal}>{doc.Vendedor}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan="8" style={styles.colNormal}>TOTALES</td>
                                            <td style={styles.colNumber}>{formatNumber(businessTotalUnexpired.toFixed(2))}</td>
                                            <td style={styles.colNumber}>{formatNumber(businessTotalExpired1_30.toFixed(2))}</td>
                                            <td style={styles.colNumber}>{formatNumber(businessTotalExpired31_60.toFixed(2))}</td>
                                            <td style={styles.colNumber}>{formatNumber(businessTotalExpired61_90.toFixed(2))}</td>
                                            <td style={styles.colNumber}>{formatNumber(businessTotalExpired90_M.toFixed(2))}</td>
                                            <td style={styles.colNumber}>{formatNumber(businessTotals.toFixed(2))}</td>
                                            <td />
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    )

                    branchTotalUnexpired += businessTotalUnexpired;
                    branchTotalExpired1_30 += businessTotalExpired1_30;
                    branchTotalExpired31_60 += businessTotalExpired31_60;
                    branchTotalExpired61_90 += businessTotalExpired61_90;
                    branchTotalExpired90_M += businessTotalExpired90_M;
                    branchTotals += businessTotals;

                    return documents;
                })}

                <div style={styles.fontSize}>
                    <table style={{ width: '100%' }}>
                        <tfoot>
                            <tr>
                                <td colSpan="8" style={styles.colNormal}>TOTALES GENERALES</td>
                                <td style={styles.colNumber}>{formatNumber(branchTotalUnexpired.toFixed(2))}</td>
                                <td style={styles.colNumber}>{formatNumber(branchTotalExpired1_30.toFixed(2))}</td>
                                <td style={styles.colNumber}>{formatNumber(branchTotalExpired31_60.toFixed(2))}</td>
                                <td style={styles.colNumber}>{formatNumber(branchTotalExpired61_90.toFixed(2))}</td>
                                <td style={styles.colNumber}>{formatNumber(branchTotalExpired90_M.toFixed(2))}</td>
                                <td style={styles.colNumber}>{formatNumber(branchTotals.toFixed(2))}</td>
                                <td />
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        )
    }
}

export default CreditWallet;


// last version 
// import moment from 'moment';
// import React, { Component } from 'react'
// import { Datos_Empresa, development } from "../../../libs/utils/Const";

// const formatNumber = (num = "") => {
//     const separador = ','; // separador para los miles
//     const sepDecimal = '.'; // separador para los decimales

//     let splitStr = num.split('.');
//     let splitLeft = splitStr[0];
//     let splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : '';
//     let regex = /(\d+)(\d{3})/;

//     while (regex.test(splitLeft)) { splitLeft = splitLeft.replace(regex, "$1" + separador + "$2"); }
//     return splitLeft + splitRight;
// };

// const finalDocStyles = {
//     fontSize: { fontSize: 12 },

//     colNormal: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
//     colNumber: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "right" },
// }

// const previewStyles = {
//     colNormal: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
//     colNumber: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "right" },
// }

// class CreditWallet extends Component {
//     render() {
//         const { DocsToPrint, ReportsModel, finalDoc } = this.props;
//         const styles = finalDoc ? finalDocStyles : previewStyles;

//         let branchTotalUnexpired = 0.0;
//         let branchTotalExpired1_30 = 0.0;
//         let branchTotalExpired31_60 = 0.0;
//         let branchTotalExpired61_90 = 0.0;
//         let branchTotalExpired90_M = 0.0;
//         let branchTotals = 0.0;

//         return (
//             <div className="p-4">
//                 <div className="row text-center">
//                     <div className="col-3 align-content-center" style={styles.fontSize}>
//                         <img src={development ? require('../../../images/logo_draft.svg') : require('../../../images/logo_EMPRESA.svg')} alt="Logo" />
//                         {Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}
//                     </div>
//                     <div className="col-6 align-content-center">
//                         <p className="font-weight-bold h5"> ANTIGÜEDAD DE SALDOS DE CLIENTES </p>
//                     </div>
//                     <div className="col-3 align-content-center" style={styles.fontSize}>
//                         {moment().format("DD/MM/YYYY")} - {moment().format("HH:mm:ss")} <br /> SUC: {ReportsModel.SucursalName && ReportsModel.SucursalName !== "---" ?  ReportsModel.SucursalName : "SIN SUCURSAL"}
//                     </div>
//                 </div>

//                 {Object.entries(DocsToPrint[0]).map(([key, value]) => {
//                     let businessTotalUnexpired = 0.0;
//                     let businessTotalExpired1_30 = 0.0;
//                     let businessTotalExpired31_60 = 0.0;
//                     let businessTotalExpired61_90 = 0.0;
//                     let businessTotalExpired90_M = 0.0;
//                     let businessTotals = 0.0;

//                     let documents = (
//                         <div className='row mt-3'>
//                             <div className='col-12'>
//                                 <p className="h6"> {key} </p>

//                                 <div style={styles.fontSize}>
//                                     <div className="border border-dark font-weight-bold">
//                                         <div className="row pl-3 pr-3">
//                                             <div className="col-6">
//                                                 <div className="row">
//                                                     <div className="col-1 p-1" style={styles.colNormal}> Serie </div>
//                                                     <div className="col-9">
//                                                         <div className="row">
//                                                             <div className="col-2 p-1" style={styles.colNormal}> Factura </div>
//                                                             <div className="col-2 p-1" style={styles.colNormal}> Folio SAP </div>
//                                                             <div className="col-2 p-1" style={styles.colNormal}> Tipo </div>
//                                                             <div className="col-2 p-1" style={styles.colNormal}> Fecha </div>
//                                                             <div className="col-2 p-1" style={styles.colNormal}> Vence </div>
//                                                             <div className="col-2 p-1" style={styles.colNumber}> Dias V. </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-2 p-1" style={styles.colNormal}> Condiciones </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-6">
//                                                 <div className="row">
//                                                     <div className="col-10">
//                                                         <div className="row">
//                                                             <div className="col-2 p-1" style={styles.colNumber}> No Vencido </div>
//                                                             <div className="col-2 p-1" style={styles.colNumber}> 1-30 Días </div>
//                                                             <div className="col-2 p-1" style={styles.colNumber}> 31-61 Días </div>
//                                                             <div className="col-2 p-1" style={styles.colNumber}> 61-91 Días </div>
//                                                             <div className="col-2 p-1" style={styles.colNumber}> Más de 90 D </div>
//                                                             <div className="col-2 p-1" style={styles.colNumber}> Importe </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-2 p-1" style={styles.colNormal}> Vendedor </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
                                
//                                     <div className="border border-dark">
//                                         {value.map((doc) => {
//                                             if (Number(doc.DiasVencidos) < 1) businessTotalUnexpired += Number(doc.Saldo);
//                                             else if (Number(doc.DiasVencidos) > 0 && Number(doc.DiasVencidos) < 31) businessTotalExpired1_30 += Number(doc.Saldo);
//                                             else if (Number(doc.DiasVencidos) > 30 && Number(doc.DiasVencidos) < 61) businessTotalExpired31_60 += Number(doc.Saldo);
//                                             else if (Number(doc.DiasVencidos) > 60 && Number(doc.DiasVencidos) < 91) businessTotalExpired61_90 += Number(doc.Saldo);
//                                             else if (Number(doc.DiasVencidos) > 90) businessTotalExpired90_M += Number(doc.Saldo);

//                                             businessTotals += Number(doc.Saldo);
//                                             return (
//                                                 <div className="row pl-3 pr-3">
//                                                     <div className="col-6">
//                                                         <div className="row">
//                                                             <div className="col-1 p-1" style={styles.colNormal}> {doc.Serie || "-"} </div>
//                                                             <div className="col-9">
//                                                                 <div className="row">
//                                                                     <div className="col-2 p-1" style={styles.colNormal}> {doc.DocNum} </div>
//                                                                     <div className="col-2 p-1" style={styles.colNormal}> {doc.DocNum} </div>
//                                                                     <div className="col-2 p-1" style={styles.colNormal}> {doc.isIns === 'Y' ? 'RESERVA' : 'DIRECTA'} </div>
//                                                                     <div className="col-2 p-1" style={styles.colNormal}> {moment(new Date(doc.Fecha)).format("DD/MM/YYYY")} </div>
//                                                                     <div className="col-2 p-1" style={styles.colNormal}> {moment(new Date(doc.DocDueDate)).format("DD/MM/YYYY")} </div>
//                                                                     <div className="col-2 p-1" style={styles.colNumber}> {doc.DiasVencidos} </div>
//                                                                 </div>
//                                                             </div>
//                                                             <div className="col-2 p-1" style={styles.colNormal}> {doc.Condiciones} </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-6">
//                                                         <div className="row">
//                                                             <div className="col-10">
//                                                                 <div className="row">
//                                                                     <div className="col-2 p-1" style={styles.colNumber}> {Number(doc.DiasVencidos) < 1 ? formatNumber(Number(doc.Saldo).toFixed(2)) : "0.00"} </div>
//                                                                     <div className="col-2 p-1" style={styles.colNumber}> {Number(doc.DiasVencidos) > 0 && Number(doc.DiasVencidos) < 31 ? formatNumber(Number(doc.Saldo).toFixed(2)) : "0.00"} </div>
//                                                                     <div className="col-2 p-1" style={styles.colNumber}> {Number(doc.DiasVencidos) > 30 && Number(doc.DiasVencidos) < 61 ? formatNumber(Number(doc.Saldo).toFixed(2)) : "0.00"} </div>
//                                                                     <div className="col-2 p-1" style={styles.colNumber}> {Number(doc.DiasVencidos) > 60 && Number(doc.DiasVencidos) < 91 ? formatNumber(Number(doc.Saldo).toFixed(2)) : "0.00"} </div>
//                                                                     <div className="col-2 p-1" style={styles.colNumber}> {Number(doc.DiasVencidos) > 90 ? formatNumber(Number(doc.Saldo).toFixed(2)) : "0.00"} </div>
//                                                                     <div className="col-2 p-1" style={styles.colNumber}> {formatNumber(Number(doc.Saldo).toFixed(2))} </div>
//                                                                 </div>
//                                                             </div>
//                                                             <div className="col-2 p-1" style={styles.colNormal}> {doc.Vendedor} </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             )
//                                         })}
//                                     </div>

//                                     <div className="font-weight-bold">
//                                         <div className="row pl-3 pr-3">
//                                             <div className="col-6">
//                                                 <div className="row">
//                                                     <div className="col-9" />
//                                                     <div className="col-3 p-1" style={styles.colNormal}> TOTALES </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-6">
//                                                 <div className="row">
//                                                     <div className="col-10">
//                                                         <div className="row">
//                                                             <div className="col-2 p-1" style={styles.colNumber}> { formatNumber(businessTotalUnexpired.toFixed(2)) } </div>
//                                                             <div className="col-2 p-1" style={styles.colNumber}> { formatNumber(businessTotalExpired1_30.toFixed(2)) } </div>
//                                                             <div className="col-2 p-1" style={styles.colNumber}> { formatNumber(businessTotalExpired31_60.toFixed(2)) } </div>
//                                                             <div className="col-2 p-1" style={styles.colNumber}> { formatNumber(businessTotalExpired61_90.toFixed(2)) } </div>
//                                                             <div className="col-2 p-1" style={styles.colNumber}> { formatNumber(businessTotalExpired90_M.toFixed(2)) } </div>
//                                                             <div className="col-2 p-1" style={styles.colNumber}> { formatNumber(businessTotals.toFixed(2)) } </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-2" />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     )

//                     branchTotalUnexpired += businessTotalUnexpired;
//                     branchTotalExpired1_30 += businessTotalExpired1_30;
//                     branchTotalExpired31_60 += businessTotalExpired31_60;
//                     branchTotalExpired61_90 += businessTotalExpired61_90;
//                     branchTotalExpired90_M += businessTotalExpired90_M;
//                     branchTotals += businessTotals;

//                     return documents;
//                 })}
                
//                 <div className="font-weight-bold" style={styles.fontSize}>
//                     <div className="row pl-3 pr-3">
//                         <div className="col-6">
//                             <div className="row">
//                                 <div className="col-9" />
//                                 <div className="col-3 p-1" style={styles.colNormal}> TOTALES POR SUCURSAL </div>
//                             </div>
//                         </div>
//                         <div className="col-6">
//                             <div className="row">
//                                 <div className="col-10">
//                                     <div className="row">
//                                         <div className="col-2 p-1" style={styles.colNumber}> { formatNumber(branchTotalUnexpired.toFixed(2)) } </div>
//                                         <div className="col-2 p-1" style={styles.colNumber}> { formatNumber(branchTotalExpired1_30.toFixed(2)) } </div>
//                                         <div className="col-2 p-1" style={styles.colNumber}> { formatNumber(branchTotalExpired31_60.toFixed(2)) } </div>
//                                         <div className="col-2 p-1" style={styles.colNumber}> { formatNumber(branchTotalExpired61_90.toFixed(2)) } </div>
//                                         <div className="col-2 p-1" style={styles.colNumber}> { formatNumber(branchTotalExpired90_M.toFixed(2)) } </div>
//                                         <div className="col-2 p-1" style={styles.colNumber}> { formatNumber(branchTotals.toFixed(2)) } </div>
//                                     </div>
//                                 </div>
//                                 <div className="col-2" />
//                             </div>
//                         </div>
//                     </div>

//                     <div className="row pl-3 pr-3">
//                         <div className="col-6">
//                             <div className="row">
//                                 <div className="col-9" />
//                                 <div className="col-3 p-1" style={styles.colNormal}> PORCENTAJES TOTALES </div>
//                             </div>
//                         </div>
//                         <div className="col-6">
//                             <div className="row">
//                                 <div className="col-10">
//                                     <div className="row">
//                                         <div className="col-2 p-1" style={styles.colNumber}> { formatNumber((branchTotalUnexpired / branchTotals * 100).toFixed(2)) } % </div>
//                                         <div className="col-2 p-1" style={styles.colNumber}> { formatNumber((branchTotalExpired1_30 / branchTotals * 100).toFixed(2)) } % </div>
//                                         <div className="col-2 p-1" style={styles.colNumber}> { formatNumber((branchTotalExpired31_60 / branchTotals * 100).toFixed(2)) } % </div>
//                                         <div className="col-2 p-1" style={styles.colNumber}> { formatNumber((branchTotalExpired61_90 / branchTotals * 100).toFixed(2)) } % </div>
//                                         <div className="col-2 p-1" style={styles.colNumber}> { formatNumber((branchTotalExpired90_M / branchTotals * 100).toFixed(2)) } % </div>
//                                         <div className="col-2 p-1" style={styles.colNumber}> { formatNumber((branchTotals / branchTotals * 100).toFixed(2)) } % </div>
//                                     </div>
//                                 </div>
//                                 <div className="col-2" />
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         )
//     }
// }

// export default CreditWallet
